import { Component, Input } from '@angular/core';
import { AutoCompleteSearchDropdownOptionsI } from '../autocomplete-field/autocomplete-field.interface';

@Component({
  selector: 'app-not-in-variant-field',
  templateUrl: './not-in-variant-field.component.html',
  styleUrls: ['./not-in-variant-field.component.scss']
})
export class NotInVariantFieldComponent {
  @Input('lob') lob: string;

  controlName = 'not_in_variant';

  autoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI;

  cvAutoCompleteFieldOptions: AutoCompleteSearchDropdownOptionsI = {
    searchApiUrl: '/services/api/v1/rb_masters/get-variant-by-name?lob=cv',
    dataApiUrl: '/services/api/v1/rb_masters/get-all-variants?lob=cv',
    queryParamKey: 'variant_name',
    dataIdKey: 'rb_id',
    dataNameKey: 'variant_name',
  }

  motorAutoCompleteOptions: AutoCompleteSearchDropdownOptionsI = {
    searchApiUrl: `/services/api/v1/rb_masters/get-variant-by-name?lob=motor`,
    dataApiUrl: '/services/api/v1/rb_masters/get-all-variants?lob=motor',
    queryParamKey: 'variant_name',
    dataIdKey: 'rb_id',
    dataNameKey: 'variant_name',
  }

  ngOnInit() {
    if (this.lob == 'cv') {
      this.autoCompleteFieldOptions = this.cvAutoCompleteFieldOptions;
    } else {
      this.autoCompleteFieldOptions = this.motorAutoCompleteOptions;
    }
  }
}
